import { Http } from '../helpers'

export const JobGroupService = {
  async search(params) {
    return await Http.get('/job-group', { params: params })
  },
  async autocomplete() {
    return await Http.get('/job-group/autocomplete')
  },
  async all() {
    return await Http.get('/job-group/all')
  },
  /**หมวดหมู่งานหลัก */
  async groups() {
    return await Http.get('/job-group/groups')
  },
  async view(id) {
    return await Http.get('/job-group/' + id)
  },
  async delete(id) {
    return await Http.delete('/job-group/' + id)
  },
  async create(params) {
    return await Http.post('/job-group', params)
  },
  async update(id, params) {
    return await Http.put('/job-group/' + id, params)
  },
  async getStatus() {
    return await Http.get('/job-group/status')
  },
}
